import Image from "next/image";
import {
  backgroundColorStyle,
  eyebrowColorStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";
import { Headline } from "~/ui-library";

export type FeatureTwoTextColumnsProps = {
  appearance: "dark" | "light";
  eyebrow: string;
  imageUrl?: string;
  imageAlt?: string;
  leftParagraphs: string[];
  rightParagraphs: string[];
  title: string;
};

export const FeatureTwoTextColumns: React.FC<FeatureTwoTextColumnsProps> = ({
  appearance,
  eyebrow,
  imageAlt,
  imageUrl,
  leftParagraphs,
  rightParagraphs,
  title,
}) => (
  <div
    className={backgroundColorStyle({
      appearance,
      className: "py-12 sm:py-16 lg:py-24",
    })}
  >
    <div>
      <div className="px-6 lg:mx-0 lg:px-8">
        <Headline
          as="p"
          level={6}
          className={eyebrowColorStyle({ appearance, className: "mb-2" })}
        >
          {eyebrow}
        </Headline>
        <Headline
          as="h3"
          level={2}
          className={primaryTextColorStyle({ appearance })}
        >
          {title}
        </Headline>
        <div
          className={secondaryTextColorStyle({
            appearance,
            className: "mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2",
          })}
        >
          <div>
            {leftParagraphs.map((paragraph, index) => (
              <p className={index > 0 ? "mt-8" : ""} key={index}>
                {paragraph}
              </p>
            ))}
          </div>
          <div>
            {rightParagraphs.map((paragraph, index) => (
              <p className={index > 0 ? "mt-8" : ""} key={index}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
      {imageUrl ? (
        <div className="relative overflow-hidden pt-16 lg:pt-20">
          <div className="mx-auto max-h-[45rem] md:max-w-[80rem] md:px-6 lg:px-8">
            <Image
              className="mb-[-12%] rounded-xl shadow-3 ring-1 ring-gray-900/10"
              src={imageUrl}
              alt={getValueOrDefault(imageAlt, "")}
              height={720}
              width={1280}
            />
          </div>
        </div>
      ) : null}
    </div>
  </div>
);
